import { render, staticRenderFns } from "./SimpleStatistic.vue?vue&type=template&id=5f02183a&"
import script from "./SimpleStatistic.vue?vue&type=script&lang=js&"
export * from "./SimpleStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SimpleStatistic.vue"
export default component.exports